// extracted by mini-css-extract-plugin
module.exports = {"Placeholder":"SBECq","Placeholder__keepRatio":"uSZEP","Placeholder_Icon":"rK9pk"};